import React, { useEffect, useState, useRef } from 'react'
import { useOutletContext } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Paper } from '@mui/material'
import { Container, Col, Row } from 'react-bootstrap'
import moment from 'moment'

import { FaImage } from "react-icons/fa6"

import useFetchData from 'Shared/Hooks/useFetchData'
import { apiUrl } from 'Shared/utils'
import DataTable from 'Shared/Components/DataTable'
import PopupModal from 'Shared/Components/PopupModal'

const mapping = {
  "change_smartwatch_ownership": "activityLog_changeSmartwatchOwnership",
  "add_worker": "activityLog_addWorker",
  "edit_worker": "activityLog_editWorker",
  "delete_worker": "activityLog_deleteWorker",
  "change_smartwatch_ownership": "activityLog_changeSmartwatchOwnership",
  "edit_zone_info": "activityLog_editZoneInfo",
  "edit_floorplan_coordinate": "activityLog_editFloorplanCoordinate",
  "edit_floorplan_info": "activityLog_editFloorplanInfo",
  "add_equipment": "activityLog_addEquipment",
  "edit_equipment_info": "activityLog_editEquipmentInfo",
  "edit_equipment_status": "activityLog_editEquipmentStatus",
  "delete_equipment": "activityLog_deleteEquipment",
  "add_training_record": "activityLog_addTrainingRecord",
  "add_geofencing_zone": "activityLog_addGeofencingZone",
  "edit_geofencing_zone": "activityLog_editGeofencingZone",
  "delete_geofencing_zone": "activityLog_deleteGeofencingZone",
  "assign_standby_person": "activityLog_assignStandbyPerson",
  "deassign_standby_person": "activityLog_deassignStandbyPerson"
}

const SystemLog = () => {
  const { t } = useTranslation()
  const { send } = useFetchData()
  const { setPageLoading } = useOutletContext()

  const [activityLog, setActivityLog] = useState({})

  const [roiActivityLogImage, setroiActivityLogImage] = useState()

  const tableRef = useRef()

  const loadData = async () => {
    const body = await send({
      method: "GET",
      url: `${apiUrl}/common/activity_log`,
      params: {
        "offset": (tableRef.current.getState()["page"]-1)*tableRef.current.getState()["itemsPerPage"],
        "limit": tableRef.current.getState()["itemsPerPage"]
      },
      returnType: "json"
    })

    const getDescription = (item) => {
      switch (item["action"]) {
        case "change_smartwatch_ownership":
          return <div>From <u><b>{item["original_value"] ?? "N/A"}</b></u> to <u><b>{item["new_value"]}</b></u></div>
        case "add_worker":
          return <div><u><b>{item["new_value"]}</b></u></div>
        case "edit_worker":
          return <div>From <u><b>{item["original_value"]}</b></u> to <u><b>{item["new_value"]}</b></u></div>
        case "delete_worker":
          return <div><u><b>{item["original_value"]}</b></u></div>
        default:
          return null
      }
    }

    setActivityLog({
      "data": body["data"].map((i) => ({
        "record_id": i["record_id"],
        "action_type": i["action"],
        "datetime": moment(new Date(i["datetime"])).format("YYYY-MM-DD HH:mm:ss"), 
        "action": t(mapping[i["action"]]),
        "target": i["target"],
        "description": getDescription(i),
        "performed_by": i["performed_by"],
      })),
      "count": Math.ceil(body["count"]/tableRef.current.getState()["itemsPerPage"])
    })
  }

  useEffect(() => {
    const init = async () => {
      setPageLoading(true)

      await loadData()

      setPageLoading(false)
    }

    init()
  }, [])

  const reloadData = async () => {
    tableRef.current.setTableLoading(true)

    await loadData()

    tableRef.current.setTableLoading(false)
  }

  return (<>
    <Container fluid className="mainContainer" style={{ backgroundColor: "white", borderRadius: "15px" }}>
      <Row style={{ height: "100%" }}>
        <Col xs={12} style={{ height: "100%", overflow: "auto", padding: "10px" }}>
          <Paper elevation={0} sx={{ height: "100%", display: "flex", flexFlow: "column" }}>
            <DataTable
              data={activityLog["data"]} count={activityLog["count"]} ref={tableRef} loadData={reloadData}
              columns={{
                "datetime": { "label": t("general_datetime"), "sorting": false, "nowrap": true },
                "action": { "label": t("activityLog_action"), "sorting": false, "nowrap": true },
                "target": { "label": t("activityLog_target"), "sorting": false, "nowrap": true },
                "description": { "label": t("activityLog_description"), "sorting": false, "nowrap": false },
                "performed_by": { "label": t("activityLog_performedBy"), "sorting": false, "nowrap": true },
              }}
            />
          </Paper>
        </Col>
      </Row>
    </Container> 

    <PopupModal isOpen={roiActivityLogImage != null} height="80%" width="80%" close toggle={() => setroiActivityLogImage()}>
      <div style={{ width: "100%", height: "100%", padding: "5px", overflowX: "hidden", overflowY: "hidden" }}>
        <iframe src={`${apiUrl}/templates/roi_activity_log.html?record_id=${roiActivityLogImage}`} style={{ width: "100%", height: "100%" }}/>
      </div>
    </PopupModal>
  </>)
}

export default SystemLog
